import RobotSorry from "../assets/pictures/robot_sorry.png";
import "../styles/robot.css";

export default function FailedAnswer() {
  return (
    <>
      <div className="quiz-text">Vyčerpal si svoje pokusy.</div>
      <img src={RobotSorry} className="robot" alt="Animation error"></img>
    </>
  );
}
